module.exports = __webpack_public_path__ + "static/media/minus.f418be9b.svg";